import styled from "styled-components";

export const FooterWrapper = styled.footer`
  background: linear-gradient(135deg, #1a1a1a 0%, #0f0f0f 100%);
  padding: 4rem 0 1.5rem;
  border-top: 3px solid #ff6b35;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23ff6b35" opacity="0.05"/><circle cx="75" cy="75" r="1.5" fill="%23ff6b35" opacity="0.05"/><circle cx="50" cy="10" r="0.8" fill="%23ff6b35" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    z-index: 1;
  }

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
    position: relative;
    z-index: 2;

    @media (max-width: 768px) {
      padding: 0 1rem;
    }
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.5fr 1fr 1fr;
  gap: 3rem;
  margin-bottom: 3rem;

  /* Tablet */
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 2.5rem;

    .contact-social-section {
      grid-column: 1 / -1;
    }
  }

  /* Mobile */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

export const FooterSection = styled.div`
  h3 {
    color: #ff6b35;
    margin-bottom: 1.5rem;
    font-size: 1.3rem;
    font-weight: bold;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 40px;
      height: 2px;
      background: #ff6b35;

      @media (max-width: 768px) {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 0.8rem;
  }

  a {
    color: #cccccc;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    display: inline-block;

    &:hover {
      color: #ff6b35;
      transform: translateX(5px);

      @media (max-width: 768px) {
        transform: none;
      }
    }
  }

  p {
    color: #cccccc;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  .contact-info {
    margin-top: 1.5rem;

    @media (max-width: 1024px) {
      margin-top: 1rem;
    }
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1rem;
    color: #cccccc;
    font-size: 0.9rem;

    @media (max-width: 768px) {
      justify-content: center;
      text-align: center;
    }

    svg {
      color: #ff6b35;
      font-size: 1rem;
      flex-shrink: 0;
    }

    span {
      line-height: 1.4;
    }
  }

  /* Company Section Specific */
  &.company-section {
    @media (max-width: 768px) {
      text-align: center;
      margin-bottom: 1rem;
    }
  }

  /* Navigation Section Specific */
  &.nav-section {
    @media (max-width: 1024px) and (min-width: 769px) {
      /* On tablet, keep nav section normal */
    }

    @media (max-width: 768px) {
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1rem;
      }

      li {
        margin-bottom: 0;
      }

      a {
        background: #2c2c2c;
        padding: 0.5rem 1rem;
        border-radius: 20px;
        border: 1px solid #333;
        transition: all 0.3s ease;

        &:hover {
          background: #ff6b35;
          color: #ffffff;
          transform: none;
        }
      }
    }
  }

  /* Contact & Social Section Specific */
  &.contact-social-section {
    @media (max-width: 1024px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
      align-items: start;
    }

    @media (max-width: 768px) {
      display: block;
    }
  }

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const FooterLogo = styled.div`
  font-size: 2.8rem;
  font-weight: bold;
  color: #ff6b35;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;
export const LogoContainer = styled.div`
  display: flex;
  max-width: 350px;
  width: 100%;
  height: 200px;
  align-items: center;

  justify-content: center;
  margin-top: -1rem;
  margin-bottom: 1rem;
`;

export const CompanyInfo = styled.div`
  text-align: center;
  p {
    font-size: 1rem;
    line-height: 1.6;
    max-width: 350px;

    @media (max-width: 768px) {
      max-width: none;
    }
  }

  .contact-info {
    margin-top: 1.5rem;

    @media (max-width: 1024px) {
      margin-top: 1rem;
    }
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-bottom: 1rem;
    color: #cccccc;
    font-size: 0.9rem;

    @media (max-width: 768px) {
      justify-content: center;
      text-align: center;
    }

    svg {
      color: #ff6b35;
      font-size: 1rem;
      flex-shrink: 0;
    }

    span {
      line-height: 1.4;
    }
  }
`;

export const SocialMedia = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const SocialLink = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b35, #ff8c42);
  color: #ffffff;
  border-radius: 50%;
  width: 45px;
  border: none;
  outline: none;
  height: 45px;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: linear-gradient(135deg, #e55a2b, #ff6b35);
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(255, 107, 53, 0.4);
  }

  &:active {
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 1.3rem;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid #333;
  padding-top: 2rem;
  text-align: center;

  p {
    color: #999;
    font-size: 0.9rem;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
`;

/* Additional styles for the reorganized sections */
export const ContactAndSocial = styled.div`
  .contact-info {
    margin-bottom: 2rem;

    @media (max-width: 1024px) {
      margin-bottom: 1.5rem;
    }
  }

  .social-wrapper {
    p {
      margin-bottom: 1rem;
      font-size: 0.9rem;
    }
  }
`;
